// Bilingual translations for Girona Webs landing page
// Languages: es (Spanish) | ca (Catalan)

export const translations = {
  es: {
    nav: {
      work: "Trabajos",
      services: "Servicios",
      process: "Proceso",
      contact: "Contacto",
      cta: "Reservar consulta",
    },
    hero: {
      overline: "Estudio de diseño web · Girona",
      titleA: "Webs que",
      titleB: "facturan.",
      titleC: "Diseñadas en Girona,",
      titleD: "pensadas para vender.",
      subtitle:
        "Creamos páginas web premium para negocios que ya no quieren parecerse a su competencia. Diseño editorial, código limpio y una estrategia que convierte visitas en clientes.",
      ctaPrimary: "Hablemos por WhatsApp",
      ctaSecondary: "Ver trabajos",
      meta: "Disponibles para 3 proyectos este trimestre",
    },
    marquee: [
      "Diseño editorial",
      "Desarrollo a medida",
      "SEO local Girona",
      "E-commerce premium",
      "Identidad de marca",
      "Mantenimiento mensual",
    ],
    stats: {
      title: "Cifras que cuentan una historia.",
      items: [
        { num: "+120", label: "Proyectos lanzados desde 2018" },
        { num: "94%", label: "Clientes que renuevan cada año" },
        { num: "2.7×", label: "Aumento medio de conversión" },
        { num: "14 días", label: "Tiempo medio de entrega" },
      ],
    },
    services: {
      overline: "Lo que hacemos",
      title: "Diseño que se siente caro.\nResultados que parecen mágicos.",
      list: [
        {
          n: "01",
          name: "Webs corporativas",
          desc: "Sites editoriales que posicionan tu marca por encima del precio. Tipografía cuidada, tiempos de carga récord y una narrativa pensada para vender.",
        },
        {
          n: "02",
          name: "E-commerce premium",
          desc: "Tiendas online en Shopify o WooCommerce con conversiones por encima del 3%. Checkout sin fricción y fotografía editorial incluida.",
        },
        {
          n: "03",
          name: "SEO local en Girona",
          desc: "Aparece el primero cuando tu cliente busca en Google desde Girona, Figueres o Olot. Trabajamos contenido, técnico y reseñas.",
        },
        {
          n: "04",
          name: "Mantenimiento & evolución",
          desc: "Tu web no se queda quieta. Mejoras mensuales, copias de seguridad, actualizaciones y soporte directo por WhatsApp.",
        },
      ],
    },
    process: {
      overline: "Cómo trabajamos",
      title: "Un proceso medido.\nSin sorpresas. Sin plantillas.",
      steps: [
        {
          n: "01",
          name: "Estrategia",
          desc: "Una sesión de 90 minutos para entender tu negocio, tu cliente y tu competencia. Salimos con un mapa claro de lo que vamos a construir.",
        },
        {
          n: "02",
          name: "Diseño",
          desc: "Maquetamos en Figma cada sección como si fuera la portada de una revista. Revisión en vivo y dos rondas de ajustes incluidas.",
        },
        {
          n: "03",
          name: "Desarrollo",
          desc: "Código a medida, sin plantillas pesadas. Carga en menos de 1.5 s y puntuación 95+ en Google PageSpeed.",
        },
        {
          n: "04",
          name: "Lanzamiento",
          desc: "Migración, formación y acompañamiento 30 días. Tu web sale al mundo con todo medido y todo funcionando.",
        },
      ],
    },
    gallery: {
      overline: "Trabajos recientes",
      title: "Proyectos que firmamos\ncon orgullo.",
      subtitle:
        "Una selección de webs lanzadas en los últimos 12 meses para clientes de Girona, Barcelona y Costa Brava.",
      viewAll: "Ver todos los proyectos",
      cases: [
        { name: "Mas Plana", sector: "Hotel rural · La Garrotxa" },
        { name: "Foc & Sal", sector: "Restaurante · Casco antiguo" },
        { name: "Atelier Bonastre", sector: "Joyería de autor · Barri Vell" },
        { name: "Olivera Vera", sector: "Aceite DOP · Empordà" },
        { name: "Clínica Solà", sector: "Dental · Girona centro" },
        { name: "Velvet Studio", sector: "Fotografía de bodas" },
      ],
    },
    testimonials: {
      overline: "Lo que dicen nuestros clientes",
      title: "Confianza construida\nuna web a la vez.",
      list: [
        {
          quote:
            "Pasamos de recibir 4 reservas semanales a 22. La web ya no parece una web: parece una invitación. El equipo entiende lo que es vender online.",
          name: "Laia Pujol",
          role: "Directora, Mas Plana",
        },
        {
          quote:
            "Trabajamos con tres agencias antes. Ninguna nos había escuchado de verdad. Aquí nos diseñaron la web que llevábamos años intentando explicar.",
          name: "Marc Bonastre",
          role: "Fundador, Atelier Bonastre",
        },
        {
          quote:
            "La diferencia entre tener una web y tener una web que vende. En tres meses recuperamos la inversión. Servicio impecable y trato cercano.",
          name: "Núria Comas",
          role: "Gerente, Clínica Solà",
        },
      ],
    },
    contact: {
      overline: "Hablemos",
      title: "¿Tu web debería\nverse así?",
      subtitle:
        "Reserva una consulta gratuita de 30 minutos. Revisamos tu web actual, te decimos qué cambiaríamos y si encajamos, te enviamos propuesta en 48 horas.",
      address: "Girona",
      hours: "Lun – Vie · 9:00 – 19:00",
      visit: "Visitas con cita previa",
      phoneLabel: "Teléfono",
      emailLabel: "Email",
      whatsappLabel: "WhatsApp directo",
      ctaWhatsapp: "Escribir por WhatsApp",
      ctaCall: "Enviar email",
    },
    footer: {
      tagline: "Estudio de diseño web premium en Girona desde 2018.",
      sections: {
        studio: "Estudio",
        services: "Servicios",
        contact: "Contacto",
      },
      links: {
        about: "Sobre nosotros",
        work: "Trabajos",
        process: "Proceso",
        journal: "Notas del estudio",
        web: "Webs corporativas",
        shop: "E-commerce",
        seo: "SEO local",
        care: "Mantenimiento",
      },
      legal: "© 2025 Girona Webs · Todos los derechos reservados.",
      policy: "Aviso legal · Política de privacidad",
    },
    floatingCta: "Reserva una consulta",
  },
  ca: {
    nav: {
      work: "Projectes",
      services: "Serveis",
      process: "Procés",
      contact: "Contacte",
      cta: "Reservar consulta",
    },
    hero: {
      overline: "Estudi de disseny web · Girona",
      titleA: "Webs que",
      titleB: "facturen.",
      titleC: "Dissenyades a Girona,",
      titleD: "pensades per vendre.",
      subtitle:
        "Creem pàgines web premium per a negocis que ja no volen assemblar-se a la seva competència. Disseny editorial, codi net i una estratègia que converteix visites en clients.",
      ctaPrimary: "Parlem per WhatsApp",
      ctaSecondary: "Veure projectes",
      meta: "Disponibles per a 3 projectes aquest trimestre",
    },
    marquee: [
      "Disseny editorial",
      "Desenvolupament a mida",
      "SEO local Girona",
      "E-commerce premium",
      "Identitat de marca",
      "Manteniment mensual",
    ],
    stats: {
      title: "Xifres que expliquen una història.",
      items: [
        { num: "+120", label: "Projectes llançats des de 2018" },
        { num: "94%", label: "Clients que renoven cada any" },
        { num: "2.7×", label: "Augment mitjà de conversió" },
        { num: "14 dies", label: "Temps mitjà d'entrega" },
      ],
    },
    services: {
      overline: "Què fem",
      title: "Disseny que se sent car.\nResultats que semblen màgia.",
      list: [
        {
          n: "01",
          name: "Webs corporatives",
          desc: "Sites editorials que posicionen la teva marca per sobre del preu. Tipografia cuidada, temps de càrrega rècord i una narrativa pensada per vendre.",
        },
        {
          n: "02",
          name: "E-commerce premium",
          desc: "Botigues online a Shopify o WooCommerce amb conversions per sobre del 3%. Checkout sense fricció i fotografia editorial inclosa.",
        },
        {
          n: "03",
          name: "SEO local a Girona",
          desc: "Surt el primer quan el teu client cerca a Google des de Girona, Figueres o Olot. Treballem contingut, tècnic i ressenyes.",
        },
        {
          n: "04",
          name: "Manteniment & evolució",
          desc: "La teva web no es queda quieta. Millores mensuals, còpies de seguretat, actualitzacions i suport directe per WhatsApp.",
        },
      ],
    },
    process: {
      overline: "Com treballem",
      title: "Un procés mesurat.\nSense sorpreses. Sense plantilles.",
      steps: [
        {
          n: "01",
          name: "Estratègia",
          desc: "Una sessió de 90 minuts per entendre el teu negoci, el teu client i la teva competència. En sortim amb un mapa clar del que construirem.",
        },
        {
          n: "02",
          name: "Disseny",
          desc: "Maquetem a Figma cada secció com si fos la portada d'una revista. Revisió en directe i dues rondes d'ajustos incloses.",
        },
        {
          n: "03",
          name: "Desenvolupament",
          desc: "Codi a mida, sense plantilles pesades. Càrrega en menys d'1.5 s i puntuació 95+ a Google PageSpeed.",
        },
        {
          n: "04",
          name: "Llançament",
          desc: "Migració, formació i acompanyament 30 dies. La teva web surt al món amb tot mesurat i tot funcionant.",
        },
      ],
    },
    gallery: {
      overline: "Projectes recents",
      title: "Projectes que signem\namb orgull.",
      subtitle:
        "Una selecció de webs llançades els últims 12 mesos per a clients de Girona, Barcelona i la Costa Brava.",
      viewAll: "Veure tots els projectes",
      cases: [
        { name: "Mas Plana", sector: "Hotel rural · La Garrotxa" },
        { name: "Foc & Sal", sector: "Restaurant · Barri Vell" },
        { name: "Atelier Bonastre", sector: "Joieria d'autor · Barri Vell" },
        { name: "Olivera Vera", sector: "Oli DOP · Empordà" },
        { name: "Clínica Solà", sector: "Dental · Girona centre" },
        { name: "Velvet Studio", sector: "Fotografia de bodes" },
      ],
    },
    testimonials: {
      overline: "Què diuen els nostres clients",
      title: "Confiança construïda\nuna web a la vegada.",
      list: [
        {
          quote:
            "Vam passar de rebre 4 reserves setmanals a 22. La web ja no sembla una web: sembla una invitació. L'equip entén què és vendre online.",
          name: "Laia Pujol",
          role: "Directora, Mas Plana",
        },
        {
          quote:
            "Vam treballar amb tres agències abans. Cap ens havia escoltat de veritat. Aquí ens van dissenyar la web que portàvem anys intentant explicar.",
          name: "Marc Bonastre",
          role: "Fundador, Atelier Bonastre",
        },
        {
          quote:
            "La diferència entre tenir una web i tenir una web que ven. En tres mesos vam recuperar la inversió. Servei impecable i tracte proper.",
          name: "Núria Comas",
          role: "Gerent, Clínica Solà",
        },
      ],
    },
    contact: {
      overline: "Parlem",
      title: "La teva web hauria\nde veure's així?",
      subtitle:
        "Reserva una consulta gratuïta de 30 minuts. Revisem la teva web actual, et diem què canviaríem i, si encaixem, t'enviem proposta en 48 hores.",
      address: "Girona",
      hours: "Dl – Dv · 9:00 – 19:00",
      visit: "Visites amb cita prèvia",
      phoneLabel: "Telèfon",
      emailLabel: "Email",
      whatsappLabel: "WhatsApp directe",
      ctaWhatsapp: "Escriure per WhatsApp",
      ctaCall: "Enviar email",
    },
    footer: {
      tagline: "Estudi de disseny web premium a Girona des de 2018.",
      sections: {
        studio: "Estudi",
        services: "Serveis",
        contact: "Contacte",
      },
      links: {
        about: "Sobre nosaltres",
        work: "Projectes",
        process: "Procés",
        journal: "Notes de l'estudi",
        web: "Webs corporatives",
        shop: "E-commerce",
        seo: "SEO local",
        care: "Manteniment",
      },
      legal: "© 2025 Girona Webs · Tots els drets reservats.",
      policy: "Avís legal · Política de privacitat",
    },
    floatingCta: "Reserva una consulta",
  },
};

export const CONTACT = {
  whatsappDisplay: "+34 618 22 51 21",
  whatsappNumber: "34618225121",
  email: "hola@girona-webs.com",
  location: "Girona",
  whatsappMessageEs:
    "Hola, me gustaría reservar una consulta gratuita para mi web.",
  whatsappMessageCa:
    "Hola, m'agradaria reservar una consulta gratuïta per a la meva web.",
};

export const whatsappUrl = (lang) => {
  const msg = lang === "ca" ? CONTACT.whatsappMessageCa : CONTACT.whatsappMessageEs;
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(msg)}`;
};
